import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CommonInput from "../../../components/input/CommonInput";
import CommonButton from "../../../components/button/CommonButton";
import HomeHeader from "../../../components/header/HomeHeader";
import Card from "../../../components/card";
import {
  passwordValidator,
  handleBlanckSpaceInput,
  getErrorMessage,
} from "../../../constants/globalFunction";
import { imagePath } from "../../../constants/imagePath";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";
import { FaLock, FaArrowLeft } from "react-icons/fa";
import "./ResetPassword.css";
import { appApiHandler } from "../../../api/appApiHandler";
import { string } from "../../../constants/string";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {};

  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const onChangePassword = (text) => {
    setPassword(handleBlanckSpaceInput(text));
    if (passwordError) setPasswordError("");
  };

  const onChangeConfirmPassword = (text) => {
    setConfirmPassword(handleBlanckSpaceInput(text));
    if (confirmPasswordError) setConfirmPasswordError("");
  };

  const validateValues = () => {
    let isValid = true;

    if (!password.trim()) {
      setPasswordError("Please enter password");
      isValid = false;
    } else if (!passwordValidator(password)) {
      setPasswordError(
        "Password must be at least 8 characters with uppercase, lowercase, number and special character"
      );
      isValid = false;
    } else {
      setPasswordError("");
    }

    if (!confirmPassword.trim()) {
      setConfirmPasswordError("Please enter confirm password");
      isValid = false;
    } else if (confirmPassword !== password) {
      setConfirmPasswordError("Passwords do not match");
      isValid = false;
    } else {
      setConfirmPasswordError("");
    }

    return isValid;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateValues();

    if (isValid) {
      try {
        const reqData = {
          email: email?.trim(),
          password: password.trim(),
        };

        setLoading(true);
        const response = await appApiHandler.resetPassword(reqData);
        setLoading(false);

        if (response?.status === 200) {
          navigate("/login");
        } else if (response?.message) {
          showErrorToast(getErrorMessage(response?.message));
        } else {
          showErrorToast(string.error.failed_due_to_internal_error);
        }
      } catch (err) {
        showErrorToast(string.error.failed_due_to_internal_error);
      }
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  // Redirect if no email is provided
  if (!email) {
    navigate("/forgot-password");
    return null;
  }

  return (
    <div className="reset-password-page" style={{ backgroundImage: `url(${imagePath.background})` }}>
      <HomeHeader />
      <div className="reset-password-content">
        <div className="reset-password-card">
          <img
            src={imagePath.appLogo}
            alt="Codeinfoway"
            className="reset-password-logo"
          />

          <h1 className="reset-password-title">Reset Password</h1>
          <p className="reset-password-subtext">
            This password should be different from the previous password.
          </p>

          <form onSubmit={onSubmit}>
            <CommonInput
              label="Password"
              value={password}
              onChange={onChangePassword}
              placeholder="Enter password"
              error={passwordError}
              secureTextEntry={true}
              leftIcon={<FaLock className="reset-password-icon" />}
            />

            <CommonInput
              label="Confirm Password"
              value={confirmPassword}
              onChange={onChangeConfirmPassword}
              placeholder="Enter confirm password"
              error={confirmPasswordError}
              secureTextEntry={true}
              leftIcon={<FaLock className="reset-password-icon" />}
            />

            <div className="button-row">
              <CommonButton
                title="Back"
                onPress={handleBack}
                outlined={true}
              />
              <CommonButton
                title={loading ? "Resetting..." : "Reset Password"}
                type="submit"
                disabled={loading}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
